<template>
  <div class="overviewIcons" v-bind:class="{shadow: (withShadow !== false)}">
    <span v-if="activity.allows_instant_booking">
      <i class="fa fa-bolt"></i>
    </span>
    <span v-if="activity.is_nature_tourism">
      <i class="fa fa-tree"></i>
    </span>
    <span v-if="activity.is_low_mobility_accessible">
      <i class="fa fa-wheelchair"></i>
    </span>
    <span v-if="activity.is_priced_per_occurrence">
      <i class="fa fa-users" aria-hidden="true"></i> <small>{{activity.group_min}}–{{activity.group_max}}</small>
    </span>
  </div>
</template>


<script>
import { mapState } from 'vuex';

export default {
  name: 'OverviewIcons',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      language: state => state.language,
    }),
  },
  props: {
    activity: { default: {} },
    withShadow: { default: false },
  },
};
</script>

<style lang="scss" scoped>
.overviewIcons {
  position: absolute;
  right: 6px;
  top: 12px;
}
  span {
    margin-right: 0.4em;
  }
  .fa-bolt {
  color: #FF8800;
  }
  .fa-tree, .fa-users  {
    color: #00B48D;
  }
  .fa-wheelchair {
    color: #00BCD4;
  }

.shadow i {
text-shadow: 1px 1px 1px rgba(0,0,0,0.5)
}
</style>



// WEBPACK FOOTER //
// OverviewIcons.vue?8411fcc8